import React from 'react'
import './mobile.styles.css'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Navbar from '../Navbar';
import mobileCentralHeating from './mobilePages/mobile-centralHeating';
import mobileDomesticHotWater from './mobilePages/mobile-domesticHotWater';
import mobilePoolHeating from './mobilePages/mobile-poolHeating';
import mobileProjects from './mobilePages/mobile-projects';
import mobileSolarWaterHeating from './mobilePages/mobile-solarWaterHeating';
import mobileHome from './mobilePages/mobile-home';
import LandingPage from '../LandingPage';

export const Mobile = () => {
    return (
        <>
        <Router >
          <div className="mobile">
          <Navbar />
          <Switch >
          <Route path='/' exact component={mobileHome} />
          <Route path='/landing' component={LandingPage} />
            <Route path='/central-heating' component={mobileCentralHeating} />
            <Route path='/domesticHotWater' component={mobileDomesticHotWater} />
            <Route path='/pool-heating' component={mobilePoolHeating} />
            <Route path='/solar-waterHeating' component={mobileSolarWaterHeating} />
            <Route path='/projects' component={mobileProjects} />
          </Switch>
          </div>
          </Router>
      </>
    )
}